import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

const useFetchImage = (exhibition, pavCode) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!exhibition || !pavCode) {
      console.warn("⚠️ Missing parameters for fetching image:", { exhibition, pavCode });
      setLoading(false);
      return;
    }

   
    let blobUrl = null;
    const apiUrl = `${API_BASE_URL}/files/${exhibition}/${pavCode}`;
    console.log(apiUrl);
    
    axios
      .get(apiUrl, {
        headers: { Authorization: `Bearer ${API_TOKEN}` },
        responseType: 'arraybuffer'  
      })
      .then((res) => {
        // Convert the binary data to a Blob
        const blob = new Blob([res.data], { type: 'image/jpeg' });
        
        // Create a URL for the Blob
        blobUrl = URL.createObjectURL(blob);
        setImageUrl(blobUrl);
      })
      .catch((err) => {
        console.error("Image API Error:", err);
        setError(err.message);
      })
      .finally(() => setLoading(false));

    // Clean up function to revoke the blob URL when the component unmounts
    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [exhibition, pavCode]);

  return { imageUrl, loading, error };
};

export default useFetchImage;